import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import brand from '@/brand';
import Breadcrumbs from '@/components/Breadcrumbs';
import { Col, Container, Input, Row, Table } from 'reactstrap';
import Th from '@/components/Th';
import PaginationComponent from '@/components/Paginate';
import useCategories from '@/hooks/useCategories';
import { ICategory } from '@/types/category';
import CategoryForm from '../components/Form';
import { successAlert } from '@/helpers/alerts';
import Modal from '@/components/Modal';

const AllCategoriesPage = () => {
  const {
    loading,
    data,
    sort,
    page,
    order,
    search,
    changeSort,
    changePerPage,
    perPage,
    total,
    changePage,
    changeSearch,
    updateCategory,
    createCategory,
  } = useCategories();
  const [category, setCategory] = useState<ICategory | null>(null);

  const renderRows = () =>
    data.map((category: ICategory, index: number) => (
      <tr key={`${index}-category`}>
        <td>{category.id}</td>
        <td>{category.name}</td>
        <td style={{ width: '40px' }}>{category.code}</td>
        <td className="d-flex justify-content-end">
          <button
            onClick={() => setCategory(category)}
            className="btn btn-sm btn-primary"
          >
            Modifica
          </button>
        </td>
      </tr>
    ));

  const saveOrUpdate = (category: ICategory, { setFieldError }: any) => {
    if (category.id) {
      updateCategory(category.id, category, (_res: any, err: any) => {
        if (err) {
          if (err.response && err.response.status === 422) {
            for (const key in err.response.data.errors) {
              setFieldError(key, err.response.data.errors[key][0]);
            }
          }
        } else {
          setCategory(null);
          successAlert('Categorie actualizata cu succes');
        }
      });
    } else {
      createCategory(category, (_res: any, err: any) => {
        if (err) {
          console.log(err);
        } else {
          setCategory(null);
          successAlert('Categorie creata cu succes');
        }
      });
    }
  };

  return (
    <React.Fragment>
      <Helmet>
        <title>Categorii - {brand.name}</title>
      </Helmet>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title={brand.shortName} breadcrumbItem="Categorii" />
          <div className="card">
            <div className="card-body">
              <div className="card-title">Categorii Produse</div>
              <Row>
                <Col md={6}>
                  <div className="form-group">
                    <button
                      onClick={() => setCategory({} as ICategory)}
                      className="btn btn-primary"
                    >
                      Adauga
                    </button>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="form-group">
                    <Input
                      type="text"
                      name="search"
                      id="search"
                      value={search}
                      placeholder="Cauta..."
                      onChange={(e) => changeSearch(e.target.value)}
                    />
                  </div>
                </Col>
              </Row>
              <Table responsive hover striped>
                <thead>
                  <tr>
                    <Th
                      prop="id"
                      order={order}
                      width="40px"
                      sort={sort}
                      onClick={changeSort}
                    >
                      #
                    </Th>

                    <Th
                      prop="name"
                      order={order}
                      sort={sort}
                      onClick={changeSort}
                    >
                      Nume
                    </Th>
                    <Th
                      prop="code"
                      order={order}
                      width="40px"
                      sort={sort}
                      onClick={changeSort}
                    >
                      Cod
                    </Th>
                    <th className="d-flex justify-content-end">Actiuni</th>
                  </tr>
                </thead>
                <tbody>
                  {loading && (
                    <tr>
                      <td colSpan={6}>Loading...</td>
                    </tr>
                  )}
                  {renderRows()}
                </tbody>
              </Table>
            </div>
            <div className="d-flex justify-content-center align-items-center p-3">
              <PaginationComponent
                page={page}
                perPage={perPage}
                total={total}
                onClick={(p) => changePage(p)}
              />
              <div
                className={`form-group d-flex align-items-center ${
                  total < 11 ? 'd-none' : ''
                }`}
              >
                <select
                  className="form-control"
                  id="perPage"
                  style={{ width: '40px' }}
                  value={perPage}
                  onChange={(e) => changePerPage(parseInt(e.target.value))}
                >
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="30">30</option>
                  <option value="40">40</option>
                  <option value="50">50</option>
                </select>
                {'   '} - pe pagina din {total}
              </div>
            </div>
          </div>
        </Container>
      </div>
      {category && (
        <Modal
          title={category.id ? 'Modifica Categorie' : 'Adauga Categorie'}
          open={!!category}
          toggle={() => setCategory(null)}
        >
          <CategoryForm category={category} onSubmit={saveOrUpdate} />
        </Modal>
      )}
    </React.Fragment>
  );
};

export default AllCategoriesPage;
